// import { trackEvent } from "services/analytics";
import ModalCreateTicket from "./modalCreateTicket";
import ModalImages from "./modalImages";
import ModalSuccess from "./modalSuccess";
import { useState, useEffect } from "react";
import { createTicket } from "store/action/ticket";

export default function CreateTicket(props) {
  const [activeImage, setActiveImage] = useState(0);
  const [input, setInput] = useState({
    orderIds: "",
    title: "",
    type: "",
    firstCategoryValue: "",
    description: "",
    images: [],
  });
  const [createTicketLoading, setCreateTicketLoading] = useState(false);
  const onCreateTicket = async () => {
    // trackEvent("Ticket SubmitTicket");
    try {
      setCreateTicketLoading(true);
      const resCreateTicket = await createTicket(input);
      if (resCreateTicket.success) {
        // trackEvent("Ticket SuccessSubmit");
        props.setModalType("success");
      } else {
        alert("Gagal membuat tiket bantuan. Silahkan coba kembali");
      }

      setCreateTicketLoading(false);
    } catch (error) {
      console.log(error);
      setCreateTicketLoading(false);
    }
  };

  useEffect(() => {
    if (props.orderId) setInput({ ...input, orderIds: props.orderId });
  }, [props.orderId]);

  return (
    <>
      {(props.modalType === "input" || props.modalType === "ticket") && (
        <ModalCreateTicket
          show={props.openModal}
          onClose={props.setOpenModal}
          setModalType={props.setModalType}
          setActiveImage={setActiveImage}
          input={input}
          setInput={setInput}
          submitLoading={createTicketLoading}
          onSubmit={onCreateTicket}
        />
      )}
      {props.modalType === "image" && (
        <ModalImages
          from="createModal"
          images={input.images}
          activeImage={activeImage}
          show={props.openModal}
          setActiveImage={setActiveImage}
          onClose={() => props.setModalType("input")}
        />
      )}
      {props.modalType === "success" && (
        <ModalSuccess
          show={props.openModal}
          setActiveImage={setActiveImage}
          onClose={props.onCloseSuccessModal}
        />
      )}
    </>
  );
}
